import { generateClampFromMax } from '@/utils/styling';
import styled, { css } from 'styled-components';
import { TTypographyColor } from '../Typography/Typography';

export const Button = styled.button.withConfig({
  shouldForwardProp: (prop) =>
    !['scaleOnHover', 'inverseRow', 'backgroundColor'].includes(prop),
})<{
  scaleOnHover: boolean;
  inverseRow: boolean;
  backgroundColor?: TTypographyColor;
}>`
  all: unset;
  display: inline-block;
  min-height: 44px;
  min-width: 44px;
  cursor: pointer;
  display: flex;
  color: ${({ color }) => `var(--c-font-${color})`};
  align-items: center;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? `var(--c-font-${backgroundColor})` : 'transparent'};
  justify-content: center;
  flex-direction: ${({ inverseRow }) => (inverseRow ? 'row-reverse' : 'row')};
  gap: ${generateClampFromMax(10)};

  span {
    color: currentColor;
    transition:
      color var(--tr-base),
      background-color var(--tr-base);
  }

  ${({ scaleOnHover }) =>
    scaleOnHover &&
    css`
      * {
        transition: transform var(--tr-base);
      }
      &:hover * {
        transform: scale(1.2);
      }
    `}

  &[data-btn-color='primary'] {
    span {
      color: var(--c-font-primary);
    }
  }

  &[data-btn-color='secondary'] {
    span {
      color: var(--c-font-secondary);
    }
  }

  &[data-is-hidden='true'] {
    opacity: 0;
    pointer-events: none;
  }

  &[data-is-active='false'] {
    opacity: 0.2;
    pointer-events: none;
  }
`;
